import { render, staticRenderFns } from "./BoxContent2.vue?vue&type=template&id=3f3b852a&scoped=true"
import script from "./BoxContent2.vue?vue&type=script&lang=js"
export * from "./BoxContent2.vue?vue&type=script&lang=js"
import style0 from "./BoxContent2.vue?vue&type=style&index=0&id=3f3b852a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3b852a",
  null
  
)

export default component.exports